<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button, RadioGroup, Radio } from "view-design";
let customerId = window.localStorage.getItem("customerId")
import config from "@/../config";
import dayjs from "dayjs";
export default {
  extends: baseList,
  data() {
    return {
      table: {
        mname: "performance",
        key: "id",
        url: {
          list: "/admin/system/fractionSum/list",
        },
        output: false,
      },
      menus: [
        {
          label: "绩效人员",
          name: "performance_list",
          auth: "",
        }, {
          label: "绩效设置",
          name: "performance_manage",
          auth: "",
        },
      ],
      filters: [
        {
          label: "时间",
          KeyEnter: this.search,
          name: "createTime",
          value: "",
          type: "datetimerangemonth",
        },
        {
          label: "姓名",
          name: "maintainerId",
          value: "",
          KeyEnter: this.search,
          type: "select",
        },
      ],
      tableCols: [
        {
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          title: "内容",
          minWidth: 180,
          align: "left",
          render: (h, p) => {
            let item = p.row;
            return (
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{ cursor: "pointer", color: "#4991ff", marginRight: "15px" }}
                  onClick={() => this.toDetails(item)}
                >
                  <span style={{ margin: "0 10px 0 0" }}>{item.maintainerName}</span>
                  <span style={{ margin: "0 10px 0 0" }}>{item.fractionSum}分</span>
                  <span>{item.createTime}</span>
                </div>
                <div onClick={() => this.editModal(item)}>
                  <Icon type="ios-create-outline" size="18" color="#515a6e" />
                </div>
              </div>
            );
          },
        },
      ],
      query: {
        createTime: dayjs().format("YYYY-MM") + "-02",
      },
      addSubState: 1,
      fraction: 0,
      performanceItem: {},
      remark:"",
    };
  },
  created() {
    this.loadLevelDatas();
  },
  methods: {
    loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/maiUser/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          console.log(res);
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.userId;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "maintainerId") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    toDetails(item) {
      $utils.url.push({
        name: "performance_details",
        query: { id: item.id },
      });
    },
    editModal(item) {
      this.performanceItem = item;
      this.fraction = 0;
      this.remark = ""
      this.$Modal.success({
        closable: true,
        title: "绩效分数管理",
        width: "800px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <div style="width:100%; margin:20px 0 0 0">
                <div style="margin-bottom:20px">
                  <RadioGroup vModel={this.addSubState}>
                    <Radio label={1} border>
                      <span>加分</span>
                    </Radio>
                    <Radio label={2} border>
                      <span>减分</span>
                    </Radio>
                  </RadioGroup>
                </div>
                <div>
                  请输入分数：
                  <InputNumber
                    min={0}
                    precision={0}
                    vModel={this.fraction}
                    style="width:100px;"
                  />
                </div>

                <div style="margin-top:20px;">
                  原因：&emsp;&emsp;&emsp;
                  <Input
                    vModel={this.remark}
                    type="textarea"
                    placeholder="请输入原因"
                    style="width:300px;"
                  />
                </div>
              </div>
              <div style="display:flex; justify-content: center; margin:40px 0;">
                <Button
                  type="primary"
                  style={{ margin: "0 20px 0 0" }}
                  onClick={() => this.onEdit()}
                >
                  确认
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    this.$Modal.remove();
                  }}
                >
                  取消
                </Button>
              </div>
            </div>
          );
        },
      });
    },
    async onEdit() {
      let d = {
        maintainerId: this.performanceItem.maintainerId,
        addSubState: this.addSubState,
        fraction: this.fraction,
        fractionId: this.performanceItem.id,
        moveBy: 3,
        remark:this.remark
      };
      // console.log(d);
      let res = await $utils.api.load("/admin/system/fractionSum", d, "post");
      if (res.code == 200) {
        this.$Modal.remove();
        if (d.addSubState == 1) {
          $utils.toast.success(`成功加${d.fraction}分`);
        } else {
          $utils.toast.success(`成功扣${d.fraction}分`);
        }
        this.search();
      }
      // console.log(res);
    },
  },
};
</script>

<style></style>
